import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-footer]')) return;

  dataLayerRelatedLinks();
  dataLayerContactLinks();
  dataLayerSocialMediaLinks();
  dataLayerHomeLinks();
  dataLayerTrustLink();
  dataLayerMultienergyLinks();
}

function dataLayerRelatedLinks() {
  $$('[data-au-footer-related-links] a').forEach((relLink) => {
    relLink.addEventListener('click', (e) => {
      let titleText = e.target
        .closest('[data-au-collapsable-parent]')
        .querySelector('[data-au-collapsable-title-text]').innerText;
      let clickText = e.target.querySelector('span:not([data-au-icon])')
        ? e.target.querySelector('span:not([data-au-icon])').innerText
        : e.target.innerText;

      titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;
      clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

      const item_id = removeAccentMarkAndUppercase(`relacionados_${titleText}_${clickText}`);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  });
}

function dataLayerContactLinks() {
  $$('[data-au-footer-contact-links] a, [data-au-footer-contact-links] button').forEach((contactLink) => {
    contactLink.addEventListener('click', (e) => {
      const titleText = e.target
        .closest('[data-au-footer-contact-block]')
        .querySelector('[data-au-footer-contact-title]').innerText;
      const clickText = e.target.querySelector('span:not([data-au-icon])').innerText;
      const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);
      let content_type;

      if (e.target.href && e.target.href.indexOf('tel:') > -1) {
        content_type = 'clickTelefono';
      } else if (e.target.href && e.target.href.indexOf('mailto:') > -1) {
        content_type = 'clickEmail';
      } else if (e.target.dataset.auFooterContactChat !== undefined) {
        content_type = 'clickChat';
      } else {
        content_type = 'clickBoton';
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'navigation',
        content_type,
        item_id,
      });
    });
  });
}

function dataLayerSocialMediaLinks() {
  $$('[data-au-footer-social-media-links] a').forEach((socialMediaLink) => {
    socialMediaLink.addEventListener('click', (e) => {
      const clickText = e.target.querySelector('span:not([data-au-icon])').innerText;
      const item_id = removeAccentMarkAndUppercase(`siguenos_${clickText}`);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  });
}

function dataLayerHomeLinks() {
  $$('[data-au-footer-home-links] a').forEach((link) => {
    link.addEventListener('click', (e) => {
      const clickText = e.currentTarget.querySelector('span').innerText;

      const item_id = removeAccentMarkAndUppercase(`logo_${clickText}`);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_content',
        content_type: 'footer',
        item_id,
      });
    });
  });
}

function dataLayerTrustLink() {
  const trustLink = $('[data-au-footer-trust-link] a');

  if (trustLink) {
    trustLink.addEventListener('click', () => {
      const item_id = 'sello confianza online';

      window.dataLayer.push({
        event: 'select_content',
        content_type: 'footer',
        item_id,
      });
    });
  }
}

function dataLayerMultienergyLinks() {
  $$('[data-au-footer-multienergy-links] [data-au-datalayer]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const clickText = e.target.innerText;

      const item_id = removeAccentMarkAndUppercase(`${clickText}`);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_content',
        content_type: 'footer',
        item_id,
      });
    });
  });
}
export default { init };
